import { DependencyList, useCallback, useEffect, useState } from 'react';

export interface PagingOptions {
  pageSizeOptions?: number[];
  resetDeps?: DependencyList;
}

export interface PagingData {
  page: number;
  pageSize: number;
  pageSizeOptions: number[];
  onPagingChange: (page: number, take: number) => void;
}

const DEFAULT_PAGE_OPTIONS = [10, 20, 50];

export const usePaging = (options?: PagingOptions): PagingData => {
  const { pageSizeOptions = DEFAULT_PAGE_OPTIONS, resetDeps = [] } =
    options || {};
  const [{ page, pageSize }, setPagingState] = useState({
    page: 1,
    pageSize: pageSizeOptions[0],
  });

  const onPagingChange = useCallback(
    (page: number, pageSize: number) => setPagingState({ page, pageSize }),
    [],
  );

  useEffect(() => {
    setPagingState((prev) => ({ ...prev, page: 1 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetDeps);

  return { page, pageSize, pageSizeOptions, onPagingChange };
};
